/**
 * convert width and fwhm to ppm
 */
export function convertWidth(peaks, options) {
    const { frequency, convertTo } = options;
    const convert = getConverter(convertTo, frequency);
    return peaks.map((peak) => {
        peak.width = convert(peak.width);
        if (hasShape(peak)) {
            if (peak.shape.fwhm) {
                peak.shape.fwhm = convert(peak.shape.fwhm);
            }
        }
        return peak;
    });
}
function hasShape(peak) {
    return 'shape' in peak;
}
function getConverter(convertTo, frequency) {
    switch (convertTo) {
        case 'ppm':
            return (x) => x / frequency;
        case 'hz':
            return (x) => x * frequency;
        default:
            throw new Error(`Does not support convert to ${convertTo}`);
    }
}
//# sourceMappingURL=convertWidth.js.map